import { render, staticRenderFns } from "./UnfoldedDateField.vue?vue&type=template&id=b280f374&"
import script from "./UnfoldedDateField.vue?vue&type=script&lang=ts&"
export * from "./UnfoldedDateField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports